import StatementUploadFormContainer from "modules/CardStatement/components/StatementUploadForm/StatementUploadForm.container";

function CorporateStatementUploadPage() {
  return <StatementUploadFormContainer cardFormat={"corporate"} />;
}

export default CorporateStatementUploadPage;
